import { createOutlaw, deleteOutlaw } from 'api/BusinessOutlawsApi';
import { BaseBusinessOutlaw, BusinessOutlaw, BusinessOutlawLocation } from 'models';
import { consoleLogInDev } from 'shared';

export function unBanHandler(
    businessOutlawId: number,
    outlawed: BusinessOutlaw[],
    resultHandler: (result: any) => void,
    refreshProviderList?: (businessId?: number, locationId?: number) => void,
) {
    deleteOutlaw(businessOutlawId)
        .then(() => {
            const res = setUnBanned(businessOutlawId, outlawed, refreshProviderList);
            resultHandler(res);
        })
        .catch(consoleLogInDev);
}

export function banHandler(
    user_id: number,
    outlawed: BusinessOutlaw[],
    locationId: number,
    businessId: number,
    resultHandler: (res: BusinessOutlaw[]) => void,
    memo?: string,
    refreshProviderList?: (businessId?: number, locationId?: number) => void,
) {
    createOutlaw(user_id, locationId, businessId, memo)
        .then((res) => {
            const banned = setBanned(res, outlawed, memo, refreshProviderList);
            resultHandler(banned ?? []);
        })
        .catch(consoleLogInDev);
}

function setUnBanned(
    businessOutlawId: number,
    outlawed: BusinessOutlaw[],
    refreshProviderList?: (businessId?: number, locationId?: number) => void,
) {
    const newOutlawed = [...outlawed];

    newOutlawed.forEach((business: BusinessOutlaw) => {
        if (business.business_outlaw_id === businessOutlawId) {
            business.business_outlaw_id = null;
            refreshProviderList?.(business.id);
        }
        business.business_locations.forEach((location: BusinessOutlawLocation) => {
            if (location.business_outlaw_id === businessOutlawId) {
                location.business_outlaw_id = null;
                refreshProviderList?.(undefined, location.id);
            }
        });
    });
    return newOutlawed;
}

function setBanned(
    businessOutlaw: BaseBusinessOutlaw,
    outlawed: BusinessOutlaw[],
    memo?: string,
    refreshProviderList?: (businessId?: number, locationId?: number) => void,
) {
    const newOutlawed = [...outlawed];
    const business = newOutlawed.find((businesses: BusinessOutlaw) => businesses.id === businessOutlaw.business);

    if (!business) return;

    const location = business.business_locations.find(
        (location: BusinessOutlawLocation) => location.id === businessOutlaw.business_location,
    );

    const banTarget = location ?? business;

    if (location) {
        refreshProviderList?.(undefined, location.id);
    } else {
        refreshProviderList?.(business.id);
    }

    banTarget.memo = memo ?? '';
    banTarget.business_outlaw_id = businessOutlaw.id;

    if (!location) {
        business.business_locations.forEach((location: any) => {
            location.memo = null;
            location.business_outlaw_id = null;
        });
    }
    return newOutlawed;
}
